import * as React from 'react'

function SvgIconListUnorderedCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="list-unordered-circle"
        aria-labelledby="t-list-unordered-circle d-list-unordered-circle"
      >
        <title id="t-list-unordered-circle">{'Circle unordered list'}</title>
        <desc id="d-list-unordered-circle">
          {'Unordered list with circles as bullets'}
        </desc>
        <path d="M30 28H12c-1.1 0-2-.9-2-2s.9-2 2-2h18c1.1 0 2 .9 2 2s-.9 2-2 2zM5 24c1.103 0 2 .896 2 2s-.897 2-2 2-2-.896-2-2 .897-2 2-2m0-1a3 3 0 100 6 3 3 0 000-6zM30 18H12c-1.1 0-2-.9-2-2s.9-2 2-2h18c1.1 0 2 .9 2 2s-.9 2-2 2zM5 14c1.103 0 2 .897 2 2 0 1.104-.897 2-2 2s-2-.896-2-2c0-1.103.897-2 2-2m0-1a3 3 0 100 6 3 3 0 000-6zM30 8H12c-1.1 0-2-.9-2-2s.9-2 2-2h18c1.1 0 2 .9 2 2s-.9 2-2 2zM5 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2m0-1a3 3 0 100 6 3 3 0 000-6z" />
      </g>
    </svg>
  )
}

export default SvgIconListUnorderedCircle
